import React, { memo } from "react";

import { makeStyles } from "@material-ui/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(24);
  return {
    icon: {
      width: size,
      height: size,
    },
  };
});

const LoadTimeIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon}>
      <mask
        id="loadTimeIcon0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M0 0H24V24H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#loadTimeIcon0)">
        <circle cx="12" cy="12" r="12" fill="white" />
        <path
          d="M12 0C15.1826 3.79521e-08 18.2348 1.26428 20.4853 3.51471C22.7357 5.76515 24 8.81739 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2349 22.7357 15.1826 24 12 24L12 12V0Z"
          fill="#51D61F"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.1231 13.798C10.4581 13.4731 10 12.79 10 12C10 11.2443 10.4191 10.5865 11.0376 10.2464C11.1171 9.33506 11.3478 8.50012 11.9999 8.50012C12.652 8.50012 12.8827 9.335 12.9623 10.2463C13.5808 10.5864 14 11.2442 14 12C14 12.7901 13.5419 13.4732 12.8767 13.7981C12.6094 16.969 11.9999 23.0001 11.9999 23.0001C11.9999 23.0001 11.3904 16.9689 11.1231 13.798Z"
          fill="black"
        />
      </g>
    </SvgIcon>
  );
};

export default memo(LoadTimeIcon);
